import { render } from "./InformedConsent.vue?vue&type=template&id=4ae24c66"
import script from "./InformedConsent.vue?vue&type=script&lang=js"
export * from "./InformedConsent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jarre\\OneDrive\\Desktop\\MSD\\msd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__